var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "password"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_139_2220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "19be197d6f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H15.1801V20.5574H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_139_2220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4194 8.33384H13.3708V5.78474C13.3747 2.59446 10.7795 0 7.58801 0C4.39625 0 1.80105 2.59446 1.80105 5.78474V8.33384H0.756376C0.340985 8.33384 0.00391388 8.67115 0.00391388 9.0863V19.8091C0.00391388 20.2203 0.340985 20.5574 0.756376 20.5574H14.4236C14.839 20.5574 15.1763 20.2203 15.1763 19.8049V9.0863C15.1721 8.67115 14.8348 8.33384 14.4194 8.33384ZM3.30647 5.78474C3.30647 3.42474 5.22728 1.50492 7.58801 1.50492C9.94875 1.50492 11.8696 3.42474 11.8696 5.78474V8.33384H3.30647V5.78474ZM8.34072 14.9863V16.9638C8.34072 17.3792 8.0034 17.7163 7.58801 17.7163C7.17262 17.7163 6.8353 17.3792 6.8353 16.9638V14.9863C6.31706 14.7149 5.96338 14.1724 5.96338 13.5515C5.96338 12.655 6.69131 11.9316 7.5838 11.9316C8.48051 11.9316 9.20422 12.6593 9.20422 13.5515C9.21265 14.1724 8.85897 14.7149 8.34072 14.9863Z",
    fill: "#807D7E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon_password.1419cbc1db7b66b3b1fbdb29427d8c4f.svg";
export { ForwardRef as ReactComponent };